import React, { useState } from 'react';
import MediaExplorer from './components/MediaExplorer/MediaExplorer';
import DmaExplorer from './components/DmaExplorer/DmaExplorer';

const path = window.location.pathname;

const MediaScope = () => {
  const [app, setApp] = useState('media-explorer');
  const [publication, setPublication] = useState('');

  const handleAppChange = (app) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mediaScopeAppChange',
      app: app ? app : 'media-explorer',
    });
    
    setApp(app);
  }

  
  return (
    <div className="container container--lg">
      <header className={`u--text-align-center`}>
        <h1>Media Scope</h1>
        <p className={`media-explorer--description ${'/marketing-is-about-changing-customer-behavior/' == path ? 'u--display-none' : ''}`}>Your Gateway to Data-Driven PR and Marketing Decisions</p>
      </header>
      <nav className="ms-tabs">
        <ul>
          <li className={app === 'media-explorer' ? 'active' : ''} onClick={() => handleAppChange('media-explorer')}>Media Explorer</li>
          <li className={app === 'dma-explorer' ? 'active' : ''} onClick={() => handleAppChange('dma-explorer')}>DMA Explorer</li>
        </ul>
      </nav>
        {app === 'media-explorer'  ? <MediaExplorer publication={publication} setPublication={setPublication}/> : <DmaExplorer />}
    </div>
  );
};

export default MediaScope;
